module.exports = __webpack_public_path__ + "img/equinox-21.734254f1.png";